import { render } from "./RateCardTable.vue?vue&type=template&id=7f95ffec"
import script from "./RateCardTable.vue?vue&type=script&lang=ts"
export * from "./RateCardTable.vue?vue&type=script&lang=ts"

import "./RateCardTable.vue?vue&type=style&index=0&id=7f95ffec&lang=scss"
script.render = render

export default script